// extracted by mini-css-extract-plugin
export default {"mainMap":"fduoyi1oMQlhW3m3kX2T"};